import { Stack } from "@mui/material";

import { type VisitWithCaseData } from "../types";
import { VisitPayInfoLabel } from "./PayInfoLabel";
import { VisitQualificationPill } from "./QualificationPill";

interface VisitCardFooterProps {
  visit: VisitWithCaseData;
  specialties: string[];
}

export function VisitCardFooter(props: VisitCardFooterProps) {
  const { visit, specialties } = props;
  const { workerReq } = visit.attributes;

  return (
    <Stack
      spacing={3}
      sx={{
        justifyContent: "space-between",
        flexDirection: "row",
      }}
    >
      <VisitQualificationPill workerRequirement={workerReq} specialties={specialties} />
      <VisitPayInfoLabel visit={visit} />
    </Stack>
  );
}
